import { CourseHeader, VideoCard } from "components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ViralAgencyCourse.module.css";

const videos = [
  {
    id: 1,
    title: "Course Introduction",
    duration: "0:39",
    size: "38.26 MiB",
    step: "Intro",
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Intro%20.mp4"
  },
  {
    id: 2,
    title: "Study your nice on social media",
    duration: "1:00",
    size: "79.55 MiB", 
    step: "Step 1",
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Step%201.mp4"
  },
  {
    id: 3,
    title: "Analyzing the competition",
    duration: "0:43",
    size: "46.91 MiB",
    step: "Step 2",
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Step%202.mp4"
  },
  {
    id: 4,
    title: "Choosing the style of video", 
    duration: "31:31",
    size: "3.06 GiB",
    step: "Step 3",
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Step%203.mp4"
  },
  {
    id: 5,
    title: "Hooks",
    duration: "2:18",
    size: "125.33 MiB",
    step: "Step 4",
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Step%204.mp4"
  },
  {
    id: 6,
    title: "Delivering your core message quickly",
    duration: "1:53",
    size: "185.55 MiB",
    step: "Step 5", 
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Step%205.mp4"
  },
  {
    id: 7,
    title: "Filming",
    duration: "10:29",
    size: "951.19 MiB",
    step: "Step 6",
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Step%206%20.mp4"
  },
  {
    id: 8,
    title: "Editing",
    duration: "9:37",
    size: "897.89 MiB",
    step: "Step 7",
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Step%207.mp4"
  },
  {
    id: 9,
    title: "Course Conclusion",
    duration: "0:29",
    size: "44.2 MiB",
    step: "Outro",
    isLocked: false,
    url: "https://viralagencymethod.com/Course%20-%20Outro.mp4"
  }
];

const ViralAgencyCourse = () => {
  const [openVideo, setOpenVideo] = useState<null | { url: string, title: string }>(null);
  const [videoError, setVideoError] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);
  const handleVideoClick = (videoId: number) => {
    console.log(videoId)
    const video = videos.find(v => v.id === videoId);
    if (video) {
      console.log(video, '....')
      setOpenVideo({ url: video.url, title: video.title });
      setVideoError(false);
      setVideoLoading(true);
      console.log('Opening video modal:', video.url);
    }
  };
  const closeModal = () => {
    setOpenVideo(null);
    setVideoError(false);
    setVideoLoading(false);
  };
  const navigate = useNavigate();
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (!userData) {
      navigate('/');
      return;
    }
    try {
      const user = JSON.parse(userData);
      if (user.status !== 'succeeded') {
        navigate('/');
      }
    } catch {
      navigate('/');
    }
  }, [navigate]);
  return (
    <div className={styles.root}>
      {/* Navigation */}
      <nav className={styles.stickyNav}>
        <div className={styles.navContainer}>
          <div className={styles.navFlex}>
            <h2 className={styles.heading}>
              <span className={styles.red}>VIRAL AGENCY</span>{" "}
              <span className={styles.blue}>METHOD</span>
            </h2>
            <div className={styles.progressFlex}>
              <span className={styles.progressText}>
                Course Progress: {videos.filter(v => !v.isLocked).length}/{videos.length}
              </span>
              <div className={styles.progressBar}>
                <div className={styles.progressBarFill} />
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className={styles.container}>
        {/* Hero Section */}
        <CourseHeader />

        {/* Course Content */}
        <div className={styles.mb12}>
          <div className={`${styles.textCenter} ${styles.mb12}`}>
            <h2 className={styles.heroTitle}>
              7 Step Guide To Making Viral Social Media Content
            </h2>
            <p className={styles.heroDesc}>
              Complete video series to master viral marketing strategies and build your successful agency
            </p>
          </div>

          {/* Video Grid */}
          <div className={styles.grid}>
            {videos.map((video) => (
              <VideoCard
                key={video.id}
                title={video.title}
                duration={video.duration}
                size={video.size}
                step={video.step}
                isLocked={video.isLocked}
                onClick={() => handleVideoClick(video.id)}
              />
            ))}
          </div>
        </div>
      </div>
      {/* Video Modal */}
      {openVideo && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={closeModal}>
          <div style={{ background: '#fff', borderRadius: 8, padding: 16, maxWidth: '90vw', maxHeight: '80vh', boxShadow: '0 2px 16px rgba(0,0,0,0.2)', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <button style={{ position: 'absolute', top: 8, right: 8, fontSize: 24, background: 'none', border: 'none', cursor: 'pointer' }} onClick={closeModal}>&times;</button>
            <h3 style={{ marginBottom: 12 }}>{openVideo.title}</h3>
            {videoError ? (
              <div style={{ color: 'red', padding: 20 }}>Video load nahi ho rahi. File URL ya server check karein.</div>
            ) : (
              <>
                {videoLoading && (
                  <div style={{ textAlign: 'center', marginBottom: 8 }}>
                    <span>Loading video...</span>
                  </div>
                )}
                <video
                  src={openVideo.url}
                  controls
                  controlsList="nodownload noremoteplayback"
                  style={{ width: '100%', maxHeight: '60vh', borderRadius: 8, background: '#000' }}
                  onContextMenu={e => e.preventDefault()}
                  disablePictureInPicture
                  disableRemotePlayback
                  onLoadedData={() => setVideoLoading(false)}
                  onError={() => { setVideoError(true); setVideoLoading(false); }}
                  autoPlay
                />
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViralAgencyCourse;




